import { createQueryKeys } from '@lukemorales/query-key-factory';
import type {
  BjAdminNoticeDetailParams,
  BjAdminNoticeListParams,
  BjNoticeIndexParams,
  BjNoticeListParams,
} from '@module/apis/client-side/notice/type';

export const noticeQueryKeys = createQueryKeys('notice', {
  fetchBjAdminNoticeList: (fetchBjAdminNoticeListParams: BjAdminNoticeListParams) => [fetchBjAdminNoticeListParams],
  fetchBjAdminNoticeDetail: (fetchBjAdminNoticeDetailParams: BjAdminNoticeDetailParams) => [
    fetchBjAdminNoticeDetailParams,
  ],
  fetchBjNoticeList: (fetchBjNoticeListParams: BjNoticeListParams) => [fetchBjNoticeListParams],
  fetchBjNotice: (fetchBjNoticeParams: BjNoticeIndexParams) => [fetchBjNoticeParams],
  fetchBjNoticeWrite: () => ['bjNoticeWrite'],
  fetchBjNoticeEdit: () => ['bjNoticeEdit'],
  fetchBjNoticeDelete: () => ['bjNoticeDelete'],
});
